// extracted by mini-css-extract-plugin
export default {"content":"BackgroundPages_content__Hn1Mq"};